import React from 'react';
import { View, Text } from 'react-native';
import PropTypes from 'prop-types';
import { Base64 } from 'js-base64';
import { Large } from '@dbk/ui-text';
import Spinner from '@dbk/ui-spinner';
import BlurModal from '../../../../components/common/blur-modal';


function getURL(fileName, bytes) {
  const blob = new Blob([bytes], { type: "application/pdf" }, fileName);
  const url = URL.createObjectURL(blob);
  return url;
};

function base64ToArrayBuffer(base64) {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes.buffer;
}

function modalContent(pdfStr, screen, closePdf, onCloseBlurModel,
  headerLabel, messages, pdfDataDownloadInProgress, extType) {
  // const pdfData = encode(pdfStr);
  const pdfData =  pdfStr !== '' && getURL("filename", base64ToArrayBuffer(pdfStr));

  if (!pdfDataDownloadInProgress && !pdfData) {
    closePdf();
    return (
      <div>
        <Large>{messages['app.reports.unablePdf']}</Large>
      </div>
    );
  }
  closePdf();
  if (pdfData) {
     const url =  pdfData +'#view=fitH&toolbar=0' ;
    //const url = "http://www.pdf995.com/samples/pdf.pdf"
    return (

      <div style={{ width: "100%" }}>
        <embed src={url} width="100%" type="application/pdf" style={{ 'minHeight': screen.height - 350 }} />

      </div>
    )
  }
  return (
    <View style={{ flex: 1, justifyContent: "center", alignItems: 'center', alignSelf: 'center' }}>
      <Spinner />
    </View>
  );
}


const DocuploadPreview = ({
  modalVisible,
  doneLabel,
  onCloseBlurModel,
  headerLabel,
  closePdf,
  screen,
  pdfData,
  messages,
  pdfDataDownloadInProgress,
  extType,
  documentType }) => (

    <div  >
      {
        modalVisible ?
          <div>
            <BlurModal
              visible={modalVisible}
              doneLabel={doneLabel}
              doneVisible
              onDone={onCloseBlurModel}
              headerChildren={headerLabel}
              // size="large"
              full
            >
              {modalContent(pdfData, screen, closePdf, onCloseBlurModel, headerLabel, messages, pdfDataDownloadInProgress, extType)}
            </BlurModal>
          </div>
          : null
      }
    </div>
  );

  DocuploadPreview.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
  }),
  modalVisible: PropTypes.bool,
  pdfId: PropTypes.string,
  doneLabel: PropTypes.string,
  onCloseBlurModel: PropTypes.function,
  headerLabel: PropTypes.string,
  closePdf: PropTypes.function,
  pdfData: PropTypes.string,
};

DocuploadPreview.defaultProps = {
  modalVisible: PropTypes.bool,
  pdfId: PropTypes.string,
  doneLabel: PropTypes.string,
  onCloseBlurModel: PropTypes.function,
  headerLabel: PropTypes.string,
  closePdf: PropTypes.function,
  pdfData: PropTypes.string,
  messages: PropTypes.array,
};

export default DocuploadPreview;
